// Third Party
import * as React from 'react';

// UI

import { Typography } from '@components/typography';
import { ExpandableText } from '@components/expandable-text';

type Props = { description: string };

export const Description: React.FC<Props> = ({ description }) => {
  return (
    <div
      className="-mb-2 space-y-2"
      data-testid="@listing/about-property-section"
    >
      <Typography
        component="h2"
        variant="subtitle2"
        variantM="title3"
        data-testid="@listing/about-property-title"
      >
        About The Property
      </Typography>

      <ExpandableText
        text={description}
        maxLines={8}
        testId="@listing/about-property"
        typographyVariant="body2"
        typographyVariantM="body1"
        className="text-primary-main"
        buttonColor="primary"
        buttonVariant="text"
        buttonClassName="underline"
      />
    </div>
  );
};
